(function () {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('consortium-financiera', {
                parent: 'entity',
                url: '/consortium-financiera?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumFinanciera'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/consortium-financiera/consortium-financiera.html',
                        controller: 'ConsortiumFinancieraController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('consortium-financiera.new', {
                parent: 'consortium-financiera',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/consortium-financiera/consortium-financiera-new.html',
                        controller: 'ConsortiumFinancieraNewController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Nuevo',
                    parent: 'consortium-financiera'
                },
                resolve: {
                    entity: function () {
                        return {
                            id: null
                        };
                    },
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'consortium-financiera',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            }).state('consortium-financiera.edit', {
                parent: 'consortium-financiera',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumFinanciera'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/consortium-financiera/consortium-financiera-detail.html',
                        controller: 'ConsortiumFinancieraDetailController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Lista',
                    parent: 'consortium-financiera'
                },
                resolve: {
                    entity: ['$stateParams', 'ConsortiumFinanciera', function ($stateParams, ConsortiumFinanciera) {
                        return ConsortiumFinanciera.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'consortium-financiera',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            });
    }

})();
